export const SOURCE = 'web-cabinet';
